import React from "react";
import { Heart, Globe, Users, BookOpen, Target, Shield } from "react-feather";

const Values = () => {
	// Internal component for SDG cards
	const SDGCard = ({ number, title, color, icon }) => (
		<div
			className={`${color} p-4 rounded-2xl h-[12rem] w-full flex flex-col justify-between hover:scale-105 hover:drop-shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer shadow-xl border border-white/20 backdrop-blur-sm`}
		>
			{/* Top section with number and title side by side */}
			<div className="flex items-start gap-2">
				<div className="text-white text-xl font-bold drop-shadow-lg">
					{number}
				</div>
				<div className="text-white text-m mt-1 font-normal leading-tight flex-1 break-words text-left drop-shadow-md">
					{title}
				</div>
			</div>
			<div className="flex-1 flex items-center justify-center">
				<div className="text-white drop-shadow-lg filter brightness-110">
					{icon}
				</div>
			</div>
		</div>
	);

	return (
		<section className="bg-inherit mt-[4rem]">
			<div className="max-w-7xl mx-auto px-4">
				{/* Header Section */}
				<div className="flex flex-col lg:flex-row items-start lg:items-center justify-between mb-[2rem]">
					{/* Left Side - Title */}
					<div className="lg:w-1/2">
						<h2 className="text-2xl lg:text-3xl xl:text-4xl font-normal text-swift-dark font-generalSans">
							Our <span className="text-swift-pink">Guiding</span>{" "}
							Principles
						</h2>
					</div>
				</div>

				{/* SDG Cards Grid */}
				<div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
					<SDGCard
						number="1"
						title="EMPATHY"
						color="bg-pink-700"
						icon={<Heart size={50} />}
					/>
					<SDGCard
						number="2"
						title="SUSTAINABILITY"
						color="bg-green-700"
						icon={<Globe size={50} />}
					/>
					<SDGCard
						number="3"
						title="HUMAN-CENTERED INNOVATION"
						color="bg-orange-700"
						icon={<Users size={50} />}
					/>
					<SDGCard
						number="4"
						title="EDUCATION AS EMPOWERMENT"
						color="bg-blue-700"
						icon={<BookOpen size={50} />}
					/>
					<SDGCard
						number="5"
						title="EXECUTION & EFFICIENCY"
						color="bg-purple-700"
						icon={<Target size={50} />}
					/>
					<SDGCard
						number="6"
						title="COMMITMENT TO SOCIAL RESPONSIBILITY"
						color="bg-teal-700"
						icon={<Shield size={50} />}
					/>
				</div>
			</div>
		</section>
	);
};

export default Values;
